
import ClicKanbanDocs from './ClicKanbanDocs';

export default {
    ClicKanban : {
        config      : {isContainer: true, icon:"md-viewweek", documentation: ClicKanbanDocs.documentation },
        component   : {type: 'string', component: { name : '' }, disabled:true},
        id          : {type: 'string', component: { name : '' } },
        
        props : {
            visible      : { type: 'boolean',default: true,   component: { name: 'switch' } },
            columns      : { type: 'json',   default: [],   component: { name: 'code' } },
            tasks        : { type: 'json',   default: [],   component: { name: 'code' } },
            allowAdd     : {type: 'boolean', default: true, component: { name : 'switch' } },
            allowRemove  : {type: 'boolean', default: true, component: { name : 'switch' } },   
        },
        events : {
            change          : {type: 'string', component: { name : 'code' } },
            openTask        : {type: 'string', component: { name : 'code' } },
            createTask      : {type: 'string', component: { name : 'code' } },
            deleteTask      : {type: 'string', component: { name : 'code' } },
            updateTask      : {type: 'string', component: { name : 'code' } },
        }
    }
}